<template>
  <div class="mobile-inventory">
    <div class="mobile-header">
      <h1 class="mobile-title">
        <b-icon-box-seam class="title-icon"></b-icon-box-seam>
        Movimentações de Agrotóxicos
      </h1>
    </div>

    <div class="tab-content">
      <div class="action-header">
        <b-button class="new-movement-btn" @click="modalHeight" size="lg">
          <b-icon-plus-circle class="mr-2"></b-icon-plus-circle>
          Nova Movimentação
        </b-button>
      </div>

      <div class="filters-section">
        <div class="filter-group">
          <label for="dateStart" class="filter-label">
            <b-icon-calendar></b-icon-calendar>
            Período
          </label>
          <div class="date-inputs">
            <b-form-input
              id="dateStart"
              type="date"
              v-model="startDate"
              class="date-input"
              @change="search(false)"
            ></b-form-input>
            <b-form-input
              id="dateEnd"
              type="date"
              v-model="endDate"
              class="date-input"
              @change="search(false)"
            ></b-form-input>
          </div>
        </div>

        <div class="filter-group">
          <label for="filterType" class="filter-label">
            <b-icon-funnel></b-icon-funnel>
            Pesquisar por
          </label>
          <b-form-select
            id="filterType"
            class="filter-select"
            v-model="filterField"
            :options="filterCombobox"
            size="lg"
          ></b-form-select>
        </div>

        <div class="filter-group">
          <label for="filterType" class="filter-label">
            <b-icon-funnel></b-icon-funnel>
            Tipo Movimentação
          </label>
          <b-form-select
            id="filterType"
            class="filter-select"
            v-model="typeMov"
            :options="movTypeCombobox"
            @change="search(false)"
            size="lg"
          ></b-form-select>
        </div>

        <div style="display: flex; gap: 1rem; align-items: flex-end">
          <div class="filter-group">
            <label for="searchInput" class="filter-label">
              <b-icon-search></b-icon-search>
              Termo de busca
            </label>
            <b-form-input
              id="searchInput"
              class="filter-input"
              placeholder="Digite para pesquisar..."
              v-model="filterValue"
              @keyup.enter="addFilter"
              size="lg"
            ></b-form-input>
          </div>

          <button @click="addFilter" size="sm" class="searchBtn">
            <b-icon-plus font-scale="1.8"></b-icon-plus>
          </button>
        </div>

        <div
          class="activeFiltersContainer"
          v-if="Object.keys(appliedfilters).length > 0"
        >
          <span
            v-for="(key, index) in Object.keys(appliedfilters)"
            :key="index"
            class="filterChip"
          >
            <strong>{{ compareteFilters[key] }}:</strong>
            {{ appliedfilters[key] }}

            <b-icon-x class="removeIcon" @click="removeFilter(key)"></b-icon-x>
          </span>
          <span class="clearAllTags" @click="clearSearch(true)">Limpar</span>
        </div>

        <!-- <div class="filter-actions">
          <b-button
            @click="search"
            class="search-button"
            size="lg"
            variant="primary"
          >
            <b-icon-search class="mr-2"></b-icon-search>
            Pesquisar
          </b-button>
          <b-button
            @click="search(true)"
            class="clear-button"
            size="lg"
            variant="outline-secondary"
          >
            <b-icon-arrow-counterclockwise
              class="mr-2"
            ></b-icon-arrow-counterclockwise>
            Limpar
          </b-button>
        </div> -->

        <div class="filter-group">
          <label class="filter-label">
            <b-icon-sort-down></b-icon-sort-down>
            Ordenar por
          </label>
          <div class="order-buttons">
            <button
              class="order-btn"
              :class="{ active: typeOrdered === 'date' }"
              @click="toggleTypeOrdered('date')"
            >
              Data
            </button>
            <button
              class="order-btn"
              :class="{ active: typeOrdered === 'createdAt' }"
              @click="toggleTypeOrdered('createdAt')"
            >
              Data Criação
            </button>
          </div>
        </div>
      </div>

      <div class="results-info">
        <span class="results-text">
          <b-icon-archive></b-icon-archive>
          {{ dataLength }} movimentação{{
            dataLength !== 1 ? "ões" : ""
          }}
          encontrada{{ dataLength !== 1 ? "s" : "" }}
        </span>
      </div>

      <div v-if="loading" class="loading-state">
        <b-spinner variant="primary"></b-spinner>
        <p>Carregando movimentações...</p>
      </div>

      <div v-else-if="!loading && moviments.length === 0" class="empty-state">
        <b-icon-inbox class="empty-icon"></b-icon-inbox>
        <h3>Nenhuma movimentação encontrada</h3>
        <p>Tente ajustar os filtros de pesquisa</p>
        <b-button variant="outline-primary" @click="search(true)">
          Limpar filtros
        </b-button>
      </div>

      <div v-else class="movements-list">
        <div
          class="movement-card"
          v-for="moviment in moviments"
          :key="moviment.id"
          @click="edit(moviment.id)"
        >
          <div
            class="card-header-movement"
            :style="{ borderLeftColor: handleBorderColorLeft(moviment.tipo) }"
          >
            <div class="card-title-section">
              <h3 class="movement-name">{{ moviment.nomeProduto }}</h3>
              <span class="movement-type">
                {{ showTypeMov(moviment.tipo) }} -
                {{
                  moviment.idVenda
                    ? "Venda"
                    : moviment.idCompra
                    ? "Compra"
                    : "Manual"
                }}
              </span>
            </div>
            <div class="card-actions">
              <button
                class="delete-btn"
                @click.stop="handleOpenModalDelete(moviment.id)"
              >
                <b-icon-trash-fill></b-icon-trash-fill>
              </button>
            </div>
          </div>

          <div class="card-info-grid">
            <div class="info-item">
              <span class="info-label">Data</span>
              <span class="info-value">{{ moviment.data | moment }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">Data Criação</span>
              <span class="info-value">{{ moviment.createdAt | moment }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">Quantidade</span>
              <span class="info-value highlight">
                {{ moviment.quantidade || "--" }}
              </span>
            </div>
            <div class="info-item">
              <span class="info-label">Embalagem</span>
              <span class="info-value">{{ moviment.embalagem || "--" }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">Nº Receita</span>
              <span class="info-value">{{ moviment.receita || "--" }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">Lote</span>
              <span class="info-value">{{ moviment.lote || "--" }}</span>
            </div>
            <div class="info-item full-width">
              <span class="info-label">Nº NF-e</span>
              <span class="info-value">{{ moviment.numeroNfe || "--" }}</span>
            </div>
          </div>
        </div>
      </div>

      <div v-if="moviments.length > 0" class="pagination-section">
        <b-button
          class="pagination-btn"
          :disabled="page == 1"
          @click="previousPage(page)"
          size="lg"
          variant="outline-secondary"
        >
          <b-icon-chevron-left></b-icon-chevron-left>
          Anterior
        </b-button>
        <span class="pagination-page">Página {{ page }}</span>
        <b-button
          class="pagination-btn"
          :disabled="dataLength < 9"
          @click="nextPage(page)"
          size="lg"
          variant="outline-secondary"
        >
          Próxima
          <b-icon-chevron-right></b-icon-chevron-right>
        </b-button>
      </div>
    </div>

    <div :class="sizeModal">
      <div :class="modalContainer" v-if="colapseModal">
        <InventoryMobile :onClose="modalHeight" />
      </div>
    </div>

    <ModalConfirm
      modalName="modal-confirm-moviment-pesticides-mobile"
      title="Deseja excluir esta movimentação?"
      subtitle="Esta ação não pode ser desfeita. Deseja continuar ?"
      :rightButtonClick="deleteMoviment"
      leftButtonText="Não, obrigado!"
      rightButtonText="Sim, quero excluir!"
    />
  </div>
</template>

<script>
import moment from "moment";
import { mapMutations, mapState } from "vuex";

import InventoryMobile from "./InventoryMobile.vue";
import ModalConfirm from "../Modals/ModalConfirm.vue";

import ServiceMovimentPesticides from "../../services/serviceMovimentPesticides";
import { TypeMovimentPesticides } from "../../utils/enums/TypeMovimentPesticides";
import { HandleErrors } from "../../utils/handleErrors";

export default {
  components: {
    InventoryMobile,
    ModalConfirm,
  },
  data() {
    return {
      textPesquisa: "",
      type: "",
      startDate: "",
      endDate: "",
      colapseModal: false,
      spinDelete: false,
      modalContainer: "contentModalDisable",
      page: 1,
      dataLength: 0,
      moviments: [],
      idFromDelete: "",
      loading: false,
      filterField: "agrotoxico",
      filterValue: "",
      compareteFilters: {
        quantidade: "Quantidade",
        agrotoxico: "Agrotóxico",
        numeroNfe: "Nº NF-e",
        registroAgrotoxico: "Nº Registro",
        lote: "Nº Lote",
        receita: "Nº Receita",
      },
      appliedfilters: {},
      typeMov: "",
      filterCombobox: [
        { value: "quantidade", text: "Quantidade" },
        { value: "agrotoxico", text: "Agrotóxico" },
        { value: "numeroNfe", text: "Nº NF-e" },
        { value: "registroAgrotoxico", text: "Nº Registro" },
        { value: "lote", text: "Nº Lote" },
        { value: "receita", text: "Nº Receita" },
      ],
      movTypeCombobox: [
        { value: "", text: "Todos" },
        { value: "Compra", text: "Compra" },
        { value: "Entrada", text: "Entrada" },
        { value: "Inventario Entrada", text: "Inventario Entrada" },
        { value: "Transferência Entrada", text: "Transferência Entrada" },
        { value: "Devolução", text: "Devolução Saida" },
        { value: "Devolução Entrada", text: "Devolução Entrada" },
        { value: "Inventario Saida", text: "Inventario Saida" },
        { value: "Transferência Saida", text: "Transferência Saida" },
        { value: "Venda", text: "Venda" },
      ],
      typeOrdered: "date",
    };
  },
  methods: {
    ...mapMutations([
      "ALTER_SIZE_MODAL",
      "SET_DATA_SEARCH_FROM_MOVIMENT_PESTICIDES",
    ]),
    addFilter() {
      if (!this.filterField || !this.filterValue.trim()) return;

      this.$set(this.appliedfilters, this.filterField, this.filterValue);

      this.filterValue = "";
      this.search();
    },

    removeFilter(key) {
      this.$delete(this.appliedfilters, key);
      this.search();
    },
    async modalHeight() {
      this.colapseModal = !this.colapseModal;
      this.colapseModal
        ? this.ALTER_SIZE_MODAL("ModalGeneral")
        : this.ALTER_SIZE_MODAL("disable");

      this.modalContainer = this.modalContainer
        ? "modalContainer"
        : "contentModalDisable";

      // Prevenir scroll do body quando modal está aberto
      if (this.colapseModal) {
        document.body.style.overflow = "hidden";
        document.body.style.position = "fixed";
        document.body.style.width = "100%";
      } else {
        document.body.style.overflow = "";
        document.body.style.position = "";
        document.body.style.width = "";
      }

      if (!this.colapseModal && this.sizeModal === "disable") {
        this.SET_DATA_SEARCH_FROM_MOVIMENT_PESTICIDES({});
        await this.search(true);
      }
    },

    showTypeMov(value) {
      const typeStockMoviments = {
        Compra: "E",
        Entrada: "E",
        "Inventario Entrada": "E",
        "Transferência Entrada": "E",
        "Devolução Entrada": "E",
        Devolução: "S",
        "Inventario Saida": "S",
        "Transferência Saida": "S",
        Venda: "S",
      };

      return typeStockMoviments[value];
    },

    clearSearch(fullReset = false) {
      this.appliedfilters = {};
      this.filterValue = "";
      this.page = 1;

      if (fullReset) {
        this.startDate = "";
        this.endDate = "";
        this.typeMov = "";
      }

      this.search();
    },

    async search(reset = false) {
      this.loading = true;
      try {
        if (reset === true) {
          this.clearSearch(true);
        }

        this.moviments = await ServiceMovimentPesticides.search(
          this.appliedfilters,
          this.typeMov,
          this.page,
          this.startDate,
          this.endDate,
          this.typeOrdered
        );

        this.dataLength = this.moviments.length;
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ocorreu um problema ao buscar as movimentações",
          type: "info",
        });
      } finally {
        this.loading = false;
      }
    },

    async edit(id) {
      try {
        const movimentPerticide = await ServiceMovimentPesticides.findById(id);

        this.handleEditPurchase(movimentPerticide);
      } catch (error) {
        const message = error?.response?.data?.message;

        if (message && message.includes("NOT_ALLOWED"))
          return this.$toast.open({
            message: message.split(":")[1],
            type: "info",
          });

        const typeError = HandleErrors(error?.response?.data?.message);
        if (typeError && Object.keys(typeError).length) {
          return this.$toast.open({
            message: typeError.message,
            type: "info",
          });
        } else
          return this.$toast.open({
            message: `${error.response.data.message}`,
            type: "error",
          });
      }
    },

    async deleteMoviment() {
      try {
        this.spinDelete = true;

        await ServiceMovimentPesticides.delete(this.idFromDelete);

        await this.search();

        this.handleCloseModalDelete();

        this.$toast.open({
          message: "Movimentação removida!",
        });
      } catch (error) {
        const message = error?.response?.data?.message;

        if (message && message.includes("NOT_ALLOWED"))
          return this.$toast.open({
            message: message.split(":")[1],
            type: "info",
          });

        const typeError = HandleErrors(error?.response?.data?.message);
        if (typeError && Object.keys(typeError).length) {
          return this.$toast.open({
            message: typeError.message,
            type: "info",
          });
        } else
          return this.$toast.open({
            message: `${error.response.data.message}`,
            type: "error",
          });
      } finally {
        this.spinDelete = false;
      }
    },

    handleEditPurchase(movimentPerticide) {
      this.SET_DATA_SEARCH_FROM_MOVIMENT_PESTICIDES(movimentPerticide);
      this.modalHeight();
    },

    handleBorderColorLeft(typeMoviment) {
      if (
        typeMoviment === TypeMovimentPesticides.INVENTARIO_SAIDA ||
        typeMoviment === TypeMovimentPesticides.TRANSFERENCIA_SAIDA ||
        typeMoviment === TypeMovimentPesticides.DEVOLUCAO ||
        typeMoviment === TypeMovimentPesticides.VENDA
      ) {
        return "#c11010";
      }

      return "#0051a9";
    },

    handleOpenModalDelete(movId) {
      this.idFromDelete = movId;
      this.openModals("modal-confirm-moviment-pesticides-mobile");
    },

    handleCloseModalDelete() {
      this.idFromDelete = "";
      this.closeModals("modal-confirm-moviment-pesticides-mobile");
    },

    openModals(name) {
      this.$bvModal.show(name);
    },

    closeModals(name) {
      this.$bvModal.hide(name);
    },

    toggleTypeOrdered(value) {
      if (this.typeOrdered === value) return;

      this.typeOrdered = value;
      this.search();
    },

    nextPage(currentPage) {
      this.page = currentPage + 1;
      this.search();
    },

    previousPage(currentPage) {
      if (currentPage === 1) return;
      this.page = currentPage - 1;
      this.search();
    },
  },
  computed: {
    ...mapState({
      sizeModal: (state) => state.sizeModal,
    }),
  },
  async created() {
    this.search();
    this.ALTER_SIZE_MODAL("disable");
    this.SET_DATA_SEARCH_FROM_MOVIMENT_PESTICIDES({});
  },
  filters: {
    moment: function (date) {
      return moment(date).format("DD/MM/YYYY");
    },
  },
  beforeDestroy() {
    this.SET_DATA_SEARCH_FROM_MOVIMENT_PESTICIDES({});
    // Garantir que o scroll seja restaurado ao sair do componente
    document.body.style.overflow = "";
    document.body.style.position = "";
    document.body.style.width = "";
  },
};
</script>

<style scoped>
.activeFiltersContainer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 0 0 10px 0;
  background-color: transparent;
}

.filterChip {
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: white;
  color: #006256;
  box-shadow: 0 0 0 1px #00625645;
  padding: 4px 12px;
  border-radius: 8px;
  font-size: 11px;
  animation: fadeIn 0.3s ease;
}

.removeIcon {
  cursor: pointer;
  font-size: 16px;
  color: #006256;
  transition: color 0.2s;
}

.removeIcon:hover {
  color: #c11010;
}

.clearAllTags {
  font-size: 11px;
  color: #c11010;
  cursor: pointer;
  text-decoration: underline;
  margin-left: 5px;
}

.clearAllTags:hover {
  color: #8c0c0c;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.mobile-inventory {
  width: 100%;
  max-width: 100vw;
  overflow-x: hidden;
  padding: 0;
  font-family: "Poppins-Regular", sans-serif;
}

.mobile-header {
  background: linear-gradient(135deg, #006458 0%, #00867a 100%);
  padding: 20px 16px;
  margin-bottom: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.mobile-title {
  color: white;
  font-size: 1.4rem;
  font-weight: 700;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 12px;
  line-height: 1.3;
}

.title-icon {
  font-size: 1.6rem;
  flex-shrink: 0;
}

.tab-content {
  width: 100%;
}

.action-header {
  padding: 0 12px 16px 12px;
}

.new-movement-btn {
  width: 100%;
  padding: 14px;
  font-size: 1.05rem;
  font-weight: 600;
  background: #28a745;
  border: none;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.3s;
  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);
}

.new-movement-btn:hover,
.new-movement-btn:focus {
  background: #218838;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(40, 167, 69, 0.4);
}

.new-movement-btn:active {
  transform: translateY(0);
}

.filters-section {
  padding: 16px;
  background: #f8f9fa;
  border-radius: 8px;
  margin: 0 12px 20px 12px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.filter-label {
  font-size: 0.875rem;
  font-weight: 600;
  color: #495057;
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 0;
  word-break: break-word;
  line-height: 1.2;
}

.filter-select,
.filter-input,
.date-input {
  width: 100%;
  border: 2px solid #dee2e6;
  border-radius: 8px;
  font-size: 1rem;
  padding: 12px 14px;
  transition: all 0.2s;
  background: white;
  height: auto;
  min-height: 44px;
}

.filter-select:focus,
.filter-input:focus,
.date-input:focus {
  border-color: #006458;
  box-shadow: 0 0 0 3px rgba(0, 100, 88, 0.1);
}

.date-inputs {
  display: flex;
  gap: 8px;
  width: 100%;
}

.date-input {
  flex: 1;
  min-width: 0;
}

.filter-actions {
  display: flex;
  gap: 8px;
}

.search-button,
.clear-button {
  flex: 1;
  padding: 14px;
  font-size: 1.05rem;
  font-weight: 600;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.3s;
}

.search-button {
  background: #006458;
  border: none;
  box-shadow: 0 4px 12px rgba(0, 100, 88, 0.3);
}

.search-button:hover,
.search-button:focus {
  background: #00867a;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 100, 88, 0.4);
}

.clear-button {
  border: 2px solid #6c757d;
  background: white;
  color: #6c757d;
}

.clear-button:hover,
.clear-button:focus {
  background: #6c757d;
  color: white;
  border-color: #6c757d;
}

.order-buttons {
  display: flex;
  gap: 8px;
}

.order-btn {
  flex: 1;
  padding: 12px;
  font-size: 0.95rem;
  font-weight: 600;
  color: #495057;
  background: white;
  border: 2px solid #dee2e6;
  border-radius: 8px;
  transition: all 0.2s;
}

.order-btn.active {
  background: #006458;
  color: white;
  border-color: #006458;
}

.order-btn:active {
  transform: scale(0.98);
}

.results-info {
  padding: 12px 16px;
  margin: 0 12px 16px 12px;
  background: #e8f5f3;
  border-left: 4px solid #006458;
  border-radius: 4px;
}

.results-text {
  font-size: 0.9rem;
  font-weight: 600;
  color: #006458;
  display: flex;
  align-items: center;
  gap: 8px;
}

.loading-state {
  padding: 60px 20px;
  text-align: center;
  color: #6c757d;
}

.loading-state p {
  margin-top: 16px;
  font-size: 0.95rem;
}

.empty-state {
  padding: 60px 20px;
  text-align: center;
}

.empty-icon {
  font-size: 4rem;
  color: #adb5bd;
  margin-bottom: 16px;
}

.empty-state h3 {
  font-size: 1.25rem;
  color: #495057;
  margin-bottom: 8px;
}

.empty-state p {
  font-size: 0.95rem;
  color: #6c757d;
  margin-bottom: 24px;
}

.movements-list {
  padding: 0 12px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 20px;
}

.searchBtn {
  height: 52px !important;
  min-height: 52px !important;
  width: 40px;
  min-width: 40px;
  border-radius: 5px;
  background: #006458;
  border: none;
  box-shadow: 0 4px 12px rgba(0, 100, 88, 0.3);
  color: white;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.searchBtn:hover {
  background: rgb(205, 205, 205);
}

.movement-card {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border: 1px solid #e9ecef;
  transition: all 0.3s;
}

.movement-card:active {
  transform: scale(0.98);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12);
}

.card-header-movement {
  padding: 16px;
  background: #f8f9fa;
  border-left: 5px solid #0051a9;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
}

.card-title-section {
  flex: 1;
  min-width: 0;
}

.movement-name {
  font-size: 1.05rem;
  font-weight: 700;
  color: #212529;
  margin: 0 0 6px 0;
  line-height: 1.3;
  word-wrap: break-word;
}

.movement-type {
  font-size: 0.8rem;
  color: #6c757d;
  background: white;
  padding: 4px 8px;
  border-radius: 4px;
  display: inline-block;
  font-weight: 600;
}

.card-actions {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}

.delete-btn {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #dc3545;
  color: white;
  border: none;
  border-radius: 6px;
  transition: all 0.2s;
}

.delete-btn:active {
  transform: scale(0.95);
  background: #c82333;
}

.card-info-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  padding: 16px;
}

.info-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.info-item.full-width {
  grid-column: 1 / -1;
}

.info-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: #868e96;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.info-value {
  font-size: 0.95rem;
  font-weight: 600;
  color: #495057;
  word-wrap: break-word;
}

.info-value.highlight {
  font-size: 1.15rem;
  color: #006458;
  font-weight: 700;
}

.pagination-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 12px;
  gap: 12px;
  margin-bottom: 20px;
}

.pagination-btn {
  flex: 1;
  min-width: 100px;
  padding: 12px 16px;
  font-size: 0.95rem;
  font-weight: 600;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  transition: all 0.2s;
}

.pagination-btn:disabled {
  opacity: 0.3;
}

.pagination-page {
  font-size: 1rem;
  font-weight: 700;
  color: #495057;
  white-space: nowrap;
  padding: 0 8px;
}

.ModalGeneral {
  position: fixed !important;
  z-index: 9999 !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  height: 100vh !important;
  width: 100vw !important;
  background: #f8f9fa;
  overflow-y: auto;
  overflow-x: hidden;
  transition: all 0.3s ease-in-out;
}

.disable {
  display: none !important;
  position: fixed;
  width: 0;
  height: 0;
  left: 0;
  top: 100vh;
  background: transparent;
  visibility: hidden;
  opacity: 0;
  pointer-events: none;
  transition: all 0.3s ease-in-out;
  overflow: hidden;
}

.closeModalPurchase {
  display: flex;
  justify-content: center;
  align-items: center;
  position: sticky;
  top: 0;
  right: 0;
  z-index: 1000;
  font-size: 20px;
  width: 48px;
  height: 48px;
  background: white;
  border: none;
  color: #495057;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  border-radius: 0 0 0 8px;
  margin-left: auto;
  margin-bottom: 8px;
}

.closeModalPurchase:hover {
  background: #f8f9fa;
  color: #dc3545;
}

.closeModalPurchase:focus {
  background: #dc3545;
  color: white;
  border: none;
  box-shadow: 0 2px 8px rgba(220, 53, 69, 0.3);
}

.contentModalDisable {
  display: none !important;
  background: white;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
}

.modalContainer {
  width: 100%;
  height: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #f8f9fa;
  visibility: visible;
  opacity: 1;
  position: relative;
}

@media screen and (min-width: 375px) {
  .mobile-title {
    font-size: 1.5rem;
  }

  .movement-name {
    font-size: 1.1rem;
  }
}

@media screen and (min-width: 425px) {
  .mobile-header {
    padding: 24px 20px;
  }

  .filters-section {
    padding: 20px;
    margin: 0 16px 24px 16px;
  }

  .movements-list {
    padding: 0 16px;
  }

  .card-info-grid {
    gap: 16px;
  }

  .action-header {
    padding: 0 16px 16px 16px;
  }
}

@media screen and (min-width: 768px) {
  .mobile-inventory {
    max-width: 700px;
    margin: 0 auto;
  }

  .mobile-header {
    border-radius: 12px;
    margin: 16px;
  }

  .pagination-section {
    justify-content: center;
    gap: 20px;
  }

  .pagination-btn {
    flex: 0;
    min-width: 140px;
  }
}

@media (prefers-reduced-motion: reduce) {
  * {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}

button,
.filter-select,
.filter-input,
.date-input {
  min-height: 44px;
}

button:focus-visible,
input:focus-visible,
select:focus-visible {
  outline: 3px solid #006458;
  outline-offset: 2px;
}
</style>
